module.exports = __webpack_public_path__ + "img/logo.10d3a2d2.png";